<script lang="ts" setup>
  import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
  } from "@/components/ui/dialog"
  import Link from "@/components/ui/link/Link.vue"

  const externalLinks = {
    "How do I read my smart meter?":
      "https://www.so.energy/support/solutions/articles/7000023265-how-do-i-read-my-smart-meter",
    "My In-Home Display (IHD)":
      "https://www.so.energy/support/solutions/articles/7000058740-my-in-home-display-ihd",
    "Smart Meter Data and You: A Guide":
      "https://www.so.energy/support/solutions/articles/7000059088-smart-meter-data-and-you-a-guide",
    "See all meter reading FAQs":
      "https://www.so.energy/support/solutions/folders/7000041385",
  }
</script>

<template>
  <Dialog>
    <DialogTrigger>
      <div class="link">Issues reading a meter?</div>
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          Are you having issues with your meter readings?
        </DialogTitle>
      </DialogHeader>
      <div class="space-y-8">
        <p>
          If you had issues submitting a meter reading or submitted a reading
          incorrectly, please speak with an agent on chat, or email
          <Link class="link text-primary-600" to="mailto:help@so.energy"
            >help@so.energy</Link
          >
          a clear photo of the meter showing the meter reading and meter serial
          number.
        </p>
        <p>Alternatively, check our our FAQ pages below.</p>

        <div>
          <p class="body-text-strong">Frequently asked questions</p>
          <div v-for="(value, key, index) in externalLinks" :key="index">
            <Link :to="value" class="link">
              {{ key }}
            </Link>
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
